import React, { useEffect, useState } from 'react';
import { Card, Select } from 'antd';
import { PieChart, Pie, Tooltip, Legend, Cell, ResponsiveContainer } from 'recharts';
import { QnaTicketCountStat, UserRegisterStat } from 'model/response';
import { QA_TICKET_DESCRIPTION, QA_TICKET_STATUS } from 'utils/data';
import { Line } from 'react-chartjs-2';
import { getStatisticUserAction } from 'service/statisticService';

// Define the component
interface UserRegisterChartProps {
    data?: UserRegisterStat[];
}
const { Option } = Select;
const UserActionChart: React.FC<UserRegisterChartProps> = ({ data }) => {
    const [statRegisType, setStatRegisType] = useState('MONTH')
    const [userRegistrationData, setUserRegistrationData] = useState<UserRegisterStat[]>([]);

    const getUserRegisStatsiticData = (value: string) => {
        setStatRegisType(value)
        getStatisticUserAction(value)
            .then(response => {
                setUserRegistrationData(response)
            })
    }

    // Prepare data for the line chart without slicing, to show all available data
    const chartLabels = userRegistrationData.map((data, index) => {
        if (statRegisType === 'WEEK') {
            return `Tuần ${index + 1}`;
        } else if (statRegisType === 'MONTH') {
            return data?.extraInfo
        }
        else {
            // Monthly format
            return data?.createdDate;
        }
    });
    const chartData = userRegistrationData.map((data) => data.userCount);

    const lineChartData = {
        labels: chartLabels,
        datasets: [
            {
                label: 'Số lượt luyện đề',
                data: chartData,
                borderColor: 'rgb(231, 76, 60,0.7)', // Line color
                backgroundColor: 'rgb(231, 76, 60,0.2)',
                fill: true,
                tension: 0.4,
            },
        ],
    };

    const lineOptions = {
        responsive: true,
        maintainAspectRatio: false, // Allows custom height and width
        plugins: {
            legend: {
                display: true,
                position: 'top' as const,
            },
            title: {
                display: true,
                text: `Người dùng hoạt động ${statRegisType === 'DAY' ? '7 ngày gần nhất' :
                    statRegisType === 'WEEK' && userRegistrationData.length > 0 ? userRegistrationData[0]?.extraInfo : 'theo tháng'}`,
                font: {
                    size: 15,
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: false,
                    text: 'Date', // X-axis title
                },
            },
            y: {
                title: {
                    display: false,
                    text: 'User Count', // Y-axis title
                },
                ticks: {
                    beginAtZero: true,
                    callback: function (value: any) {
                        if (Number.isInteger(value)) {
                            return value; // Only display integer values on the y-axis
                        }
                    },

                },
            },
        },
    };

    useEffect(() => {
        getUserRegisStatsiticData(statRegisType)
    }, [statRegisType])

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <Select
                    defaultValue="MONTH"
                    className="w-fit"
                    onChange={(value) => setStatRegisType(value)}
                >
                    <Option value="DAY">Theo ngày</Option>
                    <Option value="WEEK">Theo tuần</Option>
                    <Option value="MONTH">Theo tháng</Option>
                </Select>
            </div>
            <div className="min-h-[350px] max-h-[400px]">
                <Line data={lineChartData} options={lineOptions} />
            </div>
        </div>

    );
};

export default UserActionChart;
